<template>
  <div class="mx-6 mt-4">
    <application-form :user="user" :is-new="false"/>
  </div>
</template>

<script>
import DashboardLayout from "@/Layouts/DashboardLayout";
import ApplicationForm from "@/components/Dashboard/Application/Form";

export default {
  name: "EditApplication",

  components: {
    ApplicationForm
  },

  layout: DashboardLayout,

  props: {
    user: Object
  }
}
</script>
